/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserPointsOptionRespVo } from './GetUserPointsOptionRespVo';
import {
    GetUserPointsOptionRespVoFromJSON,
    GetUserPointsOptionRespVoFromJSONTyped,
    GetUserPointsOptionRespVoToJSON,
    GetUserPointsOptionRespVoToJSONTyped,
} from './GetUserPointsOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetUserPointsOptionRespVo
 */
export interface ResponseListGetUserPointsOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetUserPointsOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetUserPointsOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetUserPointsOptionRespVo>}
     * @memberof ResponseListGetUserPointsOptionRespVo
     */
    data?: Array<GetUserPointsOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetUserPointsOptionRespVo interface.
 */
export function instanceOfResponseListGetUserPointsOptionRespVo(value: object): value is ResponseListGetUserPointsOptionRespVo {
    return true;
}

export function ResponseListGetUserPointsOptionRespVoFromJSON(json: any): ResponseListGetUserPointsOptionRespVo {
    return ResponseListGetUserPointsOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListGetUserPointsOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetUserPointsOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetUserPointsOptionRespVoFromJSON)),
    };
}

export function ResponseListGetUserPointsOptionRespVoToJSON(json: any): ResponseListGetUserPointsOptionRespVo {
    return ResponseListGetUserPointsOptionRespVoToJSONTyped(json, false);
}

export function ResponseListGetUserPointsOptionRespVoToJSONTyped(value?: ResponseListGetUserPointsOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetUserPointsOptionRespVoToJSON)),
    };
}

